
import {Component, Prop, Vue} from 'vue-property-decorator';
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import AccessUpdateForm from "@/form/salonGeneral/accessUpdate";

@Component({
    components: {FormGroup},
})
export default class AccessUpdate extends Vue {
    @Prop() form!:  AccessUpdateForm;

    async created(): Promise<void> {
        console.log('creted');
    }
}
